import React from "react"
import { useStaticQuery, graphql } from "gatsby"

const ComponentEcosistema = () => {
    const data = useStaticQuery(graphql`
    {
      nodePage(id: {eq: "e5844ebc-4e43-59ee-baa0-13f7aca24e29"}) {
        title
        body {
          value
        }
        created
      }
    }
  `)
    return (
        <div>
        <div dangerouslySetInnerHTML={{ __html: data.nodePage.body.value }}></div>
        </div>
    )
}

export default ComponentEcosistema

